import { Phone, MessageCircle, CalendarDays, Mail, MapPin, Clock } from "lucide-react";
import { Rail } from "./Rail";
import { InquiryForm } from "./InquiryForm";
import { useBooking } from "./BookingDialog";
import { telLink, whatsappLink, BUSINESS, HOURS } from "@/lib/business";

const ghost = "lb text-[11px] sm:text-xs inline-flex items-center justify-center gap-2 border border-white/60 px-4 sm:px-5 py-3 transition-colors hover:bg-white hover:text-navy";

export const Contact = () => {
  const openBooking = useBooking();
  return (
    <Rail id="kontakt" label="04 · Kontakt" labelClass="text-steel" className="shade-dark grid-dark text-paper">
      <div className="grid lg:grid-cols-2 gap-10 sm:gap-12">
        <div>
          <h2 className="dp pc-h2">Heute anfragen. Heute fahren.</h2>
          <p className="mt-4 sm:mt-6 text-sm sm:text-base text-steel max-w-md">Für Privatkunden, Autohäuser und Firmen mit Fuhrpark – rufen Sie an, schreiben Sie per WhatsApp oder buchen Sie direkt einen Termin.</p>
          <div className="mt-6 sm:mt-8 grid grid-cols-2 sm:flex sm:flex-wrap gap-3 sm:gap-4">
            <a href={telLink} className="lb text-[11px] sm:text-xs inline-flex items-center justify-center gap-2 bg-plate text-white px-4 sm:px-5 py-3 transition-colors hover:bg-plate-hover" data-testid="contact-call-btn">
              <Phone size={14} /> Jetzt anrufen
            </a>
            <a href={whatsappLink} target="_blank" rel="noopener noreferrer" className={ghost} data-testid="contact-whatsapp-btn">
              <MessageCircle size={14} /> Per WhatsApp
            </a>
            <button type="button" onClick={openBooking} className={`${ghost} col-span-2`} data-testid="contact-booking-btn">
              <CalendarDays size={14} /> Termin online buchen
            </button>
          </div>
          <div className="mt-8 sm:mt-10 space-y-3 text-sm sm:text-base text-steel">
            <a href={telLink} className="flex items-center gap-3 hover:text-white transition-colors" data-testid="contact-phone-link"><Phone size={16} /> {BUSINESS.phoneDisplay}</a>
            <a href={`mailto:${BUSINESS.email}`} className="flex items-center gap-3 hover:text-white transition-colors" data-testid="contact-email-link"><Mail size={16} /> {BUSINESS.email}</a>
            <p className="flex items-center gap-3" data-testid="contact-address"><MapPin size={16} /> {BUSINESS.street}, {BUSINESS.city}</p>
          </div>
          <div className="mt-8 sm:mt-10 border-t border-white/15 pt-6 text-sm sm:text-base" data-testid="contact-hours">
            <p className="lb text-steel flex items-center gap-2"><Clock size={14} /> Öffnungszeiten</p>
            <dl className="mt-4 grid grid-cols-[auto_1fr] gap-x-8 gap-y-2 tn">
              {HOURS.map(([day, time]) => (
                <div key={day} className="contents"><dt className="text-steel">{day}</dt><dd className="font-semibold">{time}</dd></div>
              ))}
            </dl>
          </div>
        </div>
        <InquiryForm />
      </div>
    </Rail>
  );
};
